import { Shape } from "three";
export function createRectanglePath(bakedRules) {
    const { cornerRadius } = bakedRules;
    const cornerTR = cornerRadius?.topRight ?? 0;
    const cornerBR = cornerRadius?.bottomRight ?? 0;
    const cornerBL = cornerRadius?.bottomLeft ?? 0;
    const cornerTL = cornerRadius?.topLeft ?? 0;
    const path = new Shape();
    path.moveTo(bakedRules.startPosition.x + cornerTL, bakedRules.startPosition.y);
    path.lineTo(bakedRules.endPosition.x - cornerTR, bakedRules.startPosition.y);
    if (cornerTR > 0) {
        path.absarc(bakedRules.endPosition.x - cornerTR, bakedRules.startPosition.y - cornerTR, cornerTR, 0.5 * Math.PI, 0 * Math.PI, true);
    }
    path.lineTo(bakedRules.endPosition.x, bakedRules.endPosition.y + cornerBR);
    if (cornerBR > 0) {
        path.absarc(bakedRules.endPosition.x - cornerBR, bakedRules.endPosition.y + cornerBR, cornerBR, 0 * Math.PI, 1.5 * Math.PI, true);
    }
    path.lineTo(bakedRules.startPosition.x + cornerBL, bakedRules.endPosition.y);
    if (cornerBL > 0) {
        path.absarc(bakedRules.startPosition.x + cornerBL, bakedRules.endPosition.y + cornerBL, cornerBL, 1.5 * Math.PI, 1 * Math.PI, true);
    }
    path.lineTo(bakedRules.startPosition.x, bakedRules.startPosition.y - cornerTL);
    if (cornerTL > 0) {
        path.absarc(bakedRules.startPosition.x + cornerTL, bakedRules.startPosition.y - cornerTL, cornerTL, 1 * Math.PI, 0.5 * Math.PI, true);
    }
    return path;
}
//# sourceMappingURL=rectanglePath.js.map